export const Config = {
    apiUrl: 'https://api.guid3dtour.com',
    appUrl: 'https://app.guid3dtour.com',
    matterportKey: 'p8s59bszpmbw8qp86za2skbfd'
};
